var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMplx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.557 14.074a.33.33 0 0 0 .013-.347L8.79 7.016a.3.3 0 0 0-.257-.16H5.876c-.236 0-.382.27-.262.485l4.963 8.94a.298.298 0 0 0 .514.022zm6.857 2.64c.232 0 .377-.27.257-.48l-5.1-9.218a.3.3 0 0 0-.265-.16h-2.649c-.231 0-.377.27-.257.485l5.117 9.214a.3.3 0 0 0 .257.16zm-11.443-.57c.116.214-.03.57-.265.57H5.889c-.172 0-.318-.231-.318-.407V13.07c0-.325.42-.445.579-.163l1.817 3.236z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMplx);
export default __webpack_public_path__ + "static/media/mplx.360311ffa45af72418de2ac51ae6107a.svg";
export { ForwardRef as ReactComponent };